import { connectivityService } from '~/data/connectivity/ConnectivityService';
import { periodicCheckLocal } from '~/data/local';
import { periodicCheckRemote } from '~/data/remote';
import { PeriodicChecksPayload, PeriodicCheckSaveResponse } from '~/types';

function shouldQueueOffline(err: unknown): boolean {
  return (
    !connectivityService.isOnline() ||
    (err &&
      ((err as { message?: string }).message === 'Network Error' ||
        !(err as { response?: unknown }).response))
  );
}

export class PeriodicCheckRepository {
  async submit(
    payload: PeriodicChecksPayload
  ): Promise<PeriodicCheckSaveResponse | void> {
    if (connectivityService.isOnline()) {
      try {
        return await periodicCheckRemote.save(payload);
      } catch (err) {
        if (!shouldQueueOffline(err)) {
          throw err;
        }
      }
    }
    const saved = await periodicCheckLocal.updatePeriodicChecks(payload);
    if (!saved) {
      return;
    }
    return { queued: true };
  }
}

export const periodicCheckRepository = new PeriodicCheckRepository();
